import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getMedicamentosBox(context, filtros) {
        filtros.componente = "SearchBoxMedicamentos";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentos/access/listaBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getCosmeticosBox(context, filtros) {
        filtros.componente = "SearchBoxCosmeticos";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentos/access/listaCosmeticosBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getProdutosSaudeBox(context, filtros) {
        filtros.componente = "SearchBoxProdutosSaude";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentos/access/listaProdutosSaudeBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getFarmacosBox(context, filtros) {
        filtros.componente = "SearchBoxFarmacos";
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentos/access/listaFarmacosBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getMedicamentos(context, filtros) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("medicamentos/access/listar", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    async getMedicamento(context, idMedicamento) {
        if(!JwtService.getToken()) { throw new Error("Sessão indisponível."); }
        ApiService.setHeader();
        const { data } = await ApiService.postOnce("medicamentos/access/obter", { ID_MEDICAMENTO: idMedicamento }, { timeout: 120000 });
        return data;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};